// @flow
export const once = (
  // TODO точнее описать типы
  fn: (args: any) => any
) => {
  let called = false;

  // eslint-disable-next-line consistent-return
  return (...args: mixed[]) => {
    if (!called) {
      called = true;
      return fn(...args);
    }
  };
};

export function debounce(fn: Function, ms: number) {
  let timer;
  return (...args: mixed[]) => {
    // $FlowFixMe
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, args);
    }, ms);
  };
}
